import React, { FC, ReactNode, useContext } from 'react';
import CollapseContext from './CollapseContext';

export interface CollapsibleContentProps {
  /** Sections that can be collapsed */
  children: ReactNode;
  /** Content to replace the section once it is collapsed */
  replacement?: ReactNode;
}

const CollapsibleContent: FC<React.PropsWithChildren<CollapsibleContentProps>> = ({ children, replacement }) => {
  const collapsed = useContext(CollapseContext);
  return <>{collapsed ? replacement : children}</>;
};

export default CollapsibleContent;
